import type { Round, Session, Player } from '@/schemas';

/**
 * Get all active (non-deleted) players from a session
 */
export const getActivePlayers = (session: Session | undefined): Player[] => {
  if (!session) {
    return [];
  }
  return session.players.filter((player) => !player.deletedAt);
};

/**
 * Get all active (non-deleted) rounds from a session
 */
export const getActiveRounds = (session: Session | undefined): Round[] => {
  if (!session) {
    return [];
  }
  return session.rounds.filter((round) => !round.deletedAt);
};

/**
 * Get the current (latest non-deleted) round from a session
 * Returns undefined if no active rounds exist
 */
export const getCurrentRound = (session: Session | undefined): Round | undefined => {
  if (!session) {
    return undefined;
  }
  // Find latest non-deleted round by iterating backwards
  for (let index = session.rounds.length - 1; index >= 0; index -= 1) {
    const candidate = session.rounds[index];
    if (!candidate.deletedAt) {
      return candidate;
    }
  }
  return undefined;
};
